import { render, staticRenderFns } from "./emailNotifySetting.vue?vue&type=template&id=1c3be12b&scoped=true"
import script from "./emailNotifySetting.vue?vue&type=script&lang=js"
export * from "./emailNotifySetting.vue?vue&type=script&lang=js"
import style0 from "./emailNotifySetting.vue?vue&type=style&index=0&id=1c3be12b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3be12b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3be12b')) {
      api.createRecord('1c3be12b', component.options)
    } else {
      api.reload('1c3be12b', component.options)
    }
    module.hot.accept("./emailNotifySetting.vue?vue&type=template&id=1c3be12b&scoped=true", function () {
      api.rerender('1c3be12b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/emailNotifySetting.vue"
export default component.exports